import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function ERPDev() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/1ec998fc6466563c4459d4fc44088214db6cabe8-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Enterprise Resource Planning Solutions</h1>
            <p style={{ marginBottom: '3.5rem' }}>Operate more efficiently and conduct business more effectively, with comprehensive ERP solutions.</p>
            <h3>Enterprise Resource Planning Solutions</h3>
            <p style={{ marginBottom: '3.5rem' }}>A strong business is built upon a strong foundation of core processes that all work together to grow and nurture a successful enterprise. Your human resources, supply chain, financial, and client management departments must all function simultaneously to ensure the continued success and operational efficiency of your business. ERP allows all these departments to optimize their processes and communicate more effectively, by making all business related information available in one accessible, shared environment.</p>
            <p style={{ marginBottom: '3.5rem' }}>An ERP solution allows teams and managers to make more informed decisions by collecting and analyzing company data and offering actionable insights into company performance. Our team has over a decade of experience helping business of all sizes leverage ERP solutions into more efficient business processes. We work closely with our clients to find areas of weakness within their current systems, and then create customized solutions to help them maximize productivity.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/e9ebd6663a69ae64780dd246dc8a813b8691f3c4-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default ERPDev